<app-hourglass *ngIf="!ready"></app-hourglass>
<div class="title-row">
    <span mat-dialog-title> Week of {{data.week[0].month + '/' + data.week[0].date + '/' + startYear + ' - ' + data.week[6].month + '/' + data.week[6].date + '/' + endYear}}</span>
    <button [mat-dialog-close] aria-label="Close weekly schedule" class="no-margin" mat-icon-button>
        <mat-icon class="icon-button">close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div *ngIf="ready" class="container">
        <div *ngFor="let schedule of weeklySchedules" class="sched-row">
            <label *ngFor="let participant of schedule.participants" class="recipient-label sched-item">
                <div [class]="'color-block ' + participant.color"></div>
                <div class="name">
                    {{participant.participant_name}}
                </div>
                <mat-icon *ngIf="participant.participant_type === 'INDIVIDUAL'" matTooltip="Individuals">person</mat-icon>
                <mat-icon *ngIf="participant.participant_type === 'DEVICE'" matTooltip="Channels">devices</mat-icon>
                <mat-icon *ngIf="participant.participant_type === 'GROUP'" matTooltip="Groups">supervisor_account</mat-icon>
            </label>
            <div class="info-flex sched-item"><label>Days of the week:</label>
                <span *ngFor="let dayOfWeek of schedule.days_of_week">
                {{ dayOfWeek.name.charAt(0) }}
            </span>
            </div>
            <div class="info-flex sched-item"><label>Start: </label> {{schedule.starts}}</div>
            <div class="info-flex sched-item"><label>End: </label>&nbsp;{{schedule.ends ? schedule.ends : 'never'}}</div>
        </div>
        <mat-card *ngFor="let day of data.week" class="day-container">
            <div class="info-hour-container">
                <div class="day-info">
                    {{day.name}}<br/>
                    {{day.month}}/{{day.date}}/{{calculateYear(day.month)}}
                </div>
                <div class="day-row">
                    <div *ngFor="let hour of dayValues" class="hour">
                        {{ hour }}
                    </div>
                </div>
            </div>
            <div class="day-row hour-row">
                <div *ngFor="let hour of dayValues" class="hour-tick-container">
                    <div class="hour-tick">

                    </div>
                </div>
            </div>
            <div class="day">
                <div class="block-row">
                    <div *ngFor="let participant of day.coverage; let i = index"
                         [class]="'participant ' + participant.color"
                         [style.width.%]="(participant.duration / 24) * 100">
                        <div class="block-display">
                            <mat-icon *ngIf="participant.participant_type === 'INDIVIDUAL'" matTooltip="Individuals">person</mat-icon>
                            <mat-icon *ngIf="participant.participant_type === 'DEVICE'" matTooltip="Channels">devices</mat-icon>
                            <mat-icon *ngIf="participant.participant_type === 'GROUP'" matTooltip="Groups">supervisor_account</mat-icon>
                            {{participant.participant_name}}
                        </div>
                    </div>
                </div>
            </div>

        </mat-card>
    </div>
</mat-dialog-content>
